import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import '../App.css';
import { questions } from '../question/Question';
import SingleQ from './SingleQ';

class Questions extends Component {
  state = {
    route: 'ongoing',
    i: 0,
  };

  handleNext = () => {
    var val = this.state.i;
    val++;
    this.setState({ i: val });
    this.props.StateStore.addAnswers();
    if (this.state.i >= questions.length - 1) {
      this.props.StateStore.route = 'finished';
      console.log(this.props.StateStore.Answers);
      this.props.StateStore.finalFunction();
    }
  };

  handleHome = () => {
    this.props.StateStore.route = 'home';
  };

  render() {
    return (
      <div>
        {this.props.StateStore.route !== 'finished' ? (
          <div className='container-fluid'>
            {
              /* {questions.map((q, i) => {
          return <SingleQ questionDetail={q} index={i} id={i} />;
        })} */
              <div>
                <SingleQ questionDetail={questions[this.state.i]} />
                <div className='buttonBox'>
                  <button onClick={this.handleNext}>Next</button>
                </div>
              </div>
            }
          </div>
        ) : (
          <div className='text-center thank'>
            <h1>Thank You for your valuable Time!</h1>
            <div className='buttonBox'>
              <button onClick={this.handleHome}>Go Home</button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default inject('StateStore')(observer(Questions));
